import React from "react";
import * as ReactDOM from "react-dom";
import "jquery";
// import "bootstrap/dist/js/popper.min";
// import 'bootstrap/dist/css/bootstrap.css';
import "font-awesome/css/font-awesome.css";
import "./index.css";
import "./i18n";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import "@fontsource/roboto";

import "./assets/font/BebasKai.ttf";
import App from "./App";

<script
  src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.11.0/umd/popper.min.js"
  integrity="sha384-b/U6ypiBEHpOf/4+1nzFpr53nxSS+GLCkfwBdFNTxtclqqenISfwAzpKaMNFNmj4"
  crossOrigin="anonymous"
></script>;

ReactDOM.render(<App />, document.getElementById("root"));
